'use client';

import { forwardRef } from 'react';
import type { CustomContentProps } from 'notistack';
import { closeSnackbar, SnackbarContent } from 'notistack';
import { Button, TextPassage } from '@petsmart-ui/sparky';
import './TwoLineSnackbar.scss';

interface TwoLineSnackbarProps extends CustomContentProps {
    secondaryText: string;
    onClick?: () => void;
    actionText?: string;
}

const componentClassname = 'two-line-snackbar';

export const TwoLineSnackbar = forwardRef<HTMLDivElement, TwoLineSnackbarProps>(
    ({ id, message, secondaryText, actionText, onClick, ...props }, ref) => {
        const handleActionClick = () => {
            onClick?.();
            if (id) {
                closeSnackbar(id);
            }
        };

        return (
            <SnackbarContent {...props} ref={ref}>
                <div className={componentClassname}>
                    <div className={`${componentClassname}__text`}>
                        <TextPassage>{message}</TextPassage>
                        <TextPassage>{secondaryText}</TextPassage>
                    </div>
                    {actionText && onClick && (
                        <div className={`${componentClassname}__action`}>
                            <Button
                                onClick={handleActionClick}
                                variant="link"
                                text={actionText}
                            />
                        </div>
                    )}
                </div>
            </SnackbarContent>
        );
    }
);

TwoLineSnackbar.displayName = 'TwoLineSnackbar';
